import { graphql } from '@/gql';

export const MeDoc = graphql(/* GraphQL */ `
  query Me {
    me {
      id
      email
      firstName
      lastName
      type
      status
      permissions
      roleBindings {
        role {
          id
          name
          slug
        }
        scope {
          id
          name
        }
      }
      themePreference
      defaultPage
      currentScope {
        id
        name
        beaconMajor
      }
      defaultScope {
        id
        name
      }
      allowedScopes {
        id
        name
      }
      lastLoginAt
      passkeyCount
    }
  }
`);
